import React from 'react';
import { getUniqueKey } from './NumberUtils';
import { toSlugify } from './URLUtils';

export const LOCAL_STORAGE_ELEMENT_ID = 'LOCAL_STORAGE_ELEMENT_ID';

window.showElementId = () => {
  window.localStorage.setItem(LOCAL_STORAGE_ELEMENT_ID, 1);
};

window.hideElementId = () => {
  window.localStorage.removeItem(LOCAL_STORAGE_ELEMENT_ID);
};

export const getElementID = (pageName, elementName) => {
  const id = toSlugify(pageName + (elementName ? '-' + elementName : ''));
  if (window.localStorage.getItem(LOCAL_STORAGE_ELEMENT_ID)) {
    console.log("Element ID: document.querySelector('#" + id + "');");
  }
  return id;
};

export const getParsedNewLines = (value) => {
  return value.split('\n').map((item, idx) => {
    return (
      <span key={idx}>
        {item}
        <br />
      </span>
    );
  });
};

export const getMergedClassNames = (allClassNames = []) => {
  return allClassNames.filter((c) => Boolean(c) && c.length).join(' ');
};

export const getInputFocusInFocusOutAttr = (
  focusInCallback,
  focusOutCallback,
  currName
) => {
  return {
    onFocus: (e) => {
      focusInCallback(currName || e.target.name);
    },
    onBlur: (e) => {
      focusOutCallback(currName || e.target.name);
    },
  };
};

export const getPositionByTarget = (target) => {
  const screenWidth = window.innerWidth;
  const screenHeight = window.innerHeight;
  const targetRect = target.getBoundingClientRect();
  const maxLeft = screenWidth / 2 - targetRect.width / 2;
  const maxTop = screenHeight / 2 - targetRect.height / 2;
  let obj = {
    left: true,
    right: false,
    top: true,
    bottom: false,
  };
  if (targetRect.x > maxLeft) {
    obj.left = false;
    obj.right = true;
  }
  if (targetRect.y > maxTop) {
    obj.top = false;
    obj.bottom = true;
  }
  return obj;
};

export const getHTMLWithStyleInlineForQuerySelector = (html, styles) => {
  let newHTML = html;
  let stage = document.createElement('div');
  stage.className = 'insert-style-inline-' + getUniqueKey();
  stage.style =
    'position: fixed; top: -9999; left: -9999; Width: 1px; height: 1px; opacity: 0.1; z-index: 99999;';
  document.body.appendChild(stage);
  stage.innerHTML = newHTML;
  styles.map((style, styleIndex) => {
    let elements = stage.querySelectorAll(style.querySelector);
    for (let i in elements) {
      let element = elements[i];
      if (
        typeof element === 'object' &&
        typeof element.querySelector === 'function'
      ) {
        let oldStyle = element.getAttribute('style');
        if (oldStyle) {
          element.setAttribute(
            'style',
            convertStyleObjectToInline({
              ...convertInlineStyleToObject(oldStyle),
              ...convertInlineStyleToObject(style.style),
            })
          );
        } else {
          element.setAttribute('style', style.style);
        }
      }
    }
    return styleIndex;
  });
  newHTML = stage.innerHTML;
  stage.remove();
  return newHTML;
};

export const convertInlineStyleToObject = (inlineStyle) => {
  let obj = {};
  inlineStyle.split(';').map((style, styleIndex) => {
    let styleArr = style.split(':');
    if (styleArr.length > 0) {
      obj[String(styleArr[0]).trim()] = String(styleArr[1]).trim();
    }
    return styleIndex;
  });
  return obj;
};

export const convertStyleObjectToInline = (styleObject) => {
  let inlineStyle = '';
  for (let i in styleObject) {
    inlineStyle = inlineStyle + i + ':' + styleObject[i] + ';';
  }
  return inlineStyle;
};

export const isMobile = () => {
  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i,
  ];

  return toMatch.some((toMatchItem) => {
    return navigator.userAgent.match(toMatchItem);
  });
};
export const isiPhone = () => {
  const toMatch = [/iPhone/i, /iPad/i, /iPod/i];

  return toMatch.some((toMatchItem) => {
    return navigator.userAgent.match(toMatchItem);
  });
};
